<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/log")
          i.fa.fa-file
          span.ml-1 {{ $tc("ui.logs", 2) }}
      b-breadcrumb-item
        router-link(to="/log/efightAPILog")
          i.fa.fa-history
          span.ml-1 {{ $t("ui.efight_api_log") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getEFightLogList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="totalRow" readonly)
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 60%;" v-columns-resizable)
                  thead
                    tr
                      th(width="10%")
                        span {{ $t('ui.id') }}
                      th(width="10%")
                        span {{ $tc('ui.sports', 1) }}
                      th(width="60%")
                        span {{ $t("ui.video") }}
                      th.text-right(width="17%")
                        span {{ $t("ui.created_on") }}
                      th.sticky-position.text-center(width="8%")
                          span
                  tbody.clusterize-content
                    tr(v-if="efightAPILogList.length == 0")
                      td(colspan="5").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in efightAPILogList")
                      td
                        span {{ item.id }}
                      td
                        span {{ getSportsName(item.sports_type) }}
                      td
                        span {{ item.video_name }}
                      td.text-right
                        span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
                      td.actions
                        span(href="#" @click="onViewLog(item)" :title="$t('ui.view_log')")
                          a.fa.fa-eye.text-primary
                        span(href="#" @click="onViewOutput(item)" :title="$t('ui.view_output')")
                          a.fas.fa-file.text-secondary
    efightapiloginfo(ref="efightAPILogInfo" @failed="handleFailed" :item="detailInfo")
    efightapioutputinfo(ref="efightAPIOutputInfo" @failed="handleFailed" :item="detailInfo")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import beautify from "xml-beautifier";
import DateRangePicker from "vue2-daterange-picker";
import efightapiloginfo from "@/components/log/efightAPILogInfo.vue";
import efightapioutputinfo from "@/components/log/efightAPIOutputInfo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    beautify,
    DateRangePicker,
    efightapiloginfo,
    efightapioutputinfo
  },
  data: () => ({
    loading: false,
    efightAPILogList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: 'YYYY-MM-DD hh:mm:ss A',
      useCurrent: false,
      showClear: true,
      showClose: true,
    },
    currentPage: 1,
    totalRow: 0,
    detailInfo: null,
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    todayWithTime() {
      let time = '23:59:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    }
  },
  mounted: function() {
    this.startDate = this.yesterdayWithTime;
    this.endDate = this.todayWithTime;
  },
  methods: {
    onViewOutput: function(a) {
      this.detailInfo = a;
      this.$refs.efightAPIOutputInfo.$refs.efightAPIOutputInfo.show();
    },
    onViewLog: function(a) {
      this.detailInfo = a;
      this.$refs.efightAPILogInfo.$refs.efightAPILogInfo.show();
    },
    getSportsName: function(id) {
      if (id == 43)
        return "KOF";
      else if (id == 42)
        return "UFC";
      else if (id == 45)
        return "GH";
      else if (id == 46)
        return "MB";
      else if (id == 44)
        return "MK";
      else if (id == 41)
        return "SFV";
      else if (id == 49)
        return "MR";
      else if (id == 47)
        return "TK8";
      else if (id == 50)
        return "MC";
      else if (id == 51)
        return "MS";
      else if (id == 52)
        return "DB";
      else if (id == 52)
        return "DB";
      else if (id == 53)
        return "NRT";
      else if (id == 54)
        return "MRF";
      else if (id == 55)
        return "MPS";
      else if (id == 56)
        return "CF";
      else if (id == 57)
        return "BM";

      return "";
    },
    getEFightLogList: function(isSearch) {
      let url = config.getEFightAPILogUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.efightapilog,
        date_from: this.startDate,
        date_to: this.endDate,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.efightAPILogList = response.data.tbl_efight_api_log;
                this.totalRow = this.efightAPILogList.length > 0 ? response.data.tbl_efight_api_log[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getEFightLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getEFightLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>